<template>
  <div
    class="culture"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="cultureTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"
            >Cultural and Creative Design Exhibition and Sales</span
          >
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="cultureContent">
      <div class="section">
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0">none</div>
        </div>
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0">none</div>
        </div>
        <div class="moreButton">
          <div class="button eng_botton" @click="goMoreCultureGoods">
            View more
          </div>
        </div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <img
              class="hidden-xs-only"
              src="../../assets/dataType/data_one.png"
              alt=""
            />
            <img
              class="hidden-sm-and-up"
              src="../../assets/dataType/data_one_bottom.gif"
              alt=""
            />
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_art">
              <div class="art_top eng_art_top">Regong Art</div>
              <div class="art_middle">
                Human material cultural heritage|China's Intangible Cultural
                Heritage
              </div>
              <div class="art_bottom">
                Cultural treasures|Art Inheritance|Master works
              </div>
            </div>
          </div>
        </div>
        <div class="middle_bottom wow animate__fadeIn animate__animated">
          <img
            class="hidden-xs-only"
            src="../../assets/cultural/Cultural_two.png"
            alt=""
          />
          <img
            class="hidden-sm-and-up"
            src="../../assets/cultural/Cultural_two_bottom.gif"
            alt=""
          />
          <div class="title eng_title">
            <div class="button eng_button" @click="goCulturalCustomMade()">
              AI assisted cultural and creative customization
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">Cultural and Creative Consulting</div>
          <div class="hidden-sm-and-up">Cultural and Creative Consulting</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culture" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="cultureTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་། </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="cultureContent">
      <div class="section">
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
        </div>
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
        </div>
        <div class="moreButton">
          <div class="button" @click="goMoreCultureGoods">
            འདི་ལས་མང་བར་བལྟ་བ།
          </div>
        </div>
        <div class="middle">
          <div class="za_left left wow animate__fadeInLeft animate__animated">
            <img
              class="hidden-xs-only"
              src="../../assets/dataType/data_one.png"
              alt=""
            />
            <img
              class="hidden-sm-and-up"
              src="../../assets/dataType/data_one_bottom.gif"
              alt=""
            />
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="za_right_art right_art">
              <div class="art_top">རེབ་གོང་སྒྱུ་རྩལ།</div>
              <div class="art_middle">
                མིའི་རིགས་ཀྱི་གཟུགས་བཅས་རིག་གནས་ཤུལ་བཞག
                །|ཀྲུང་གོའི་གཟུགས་མེད་ཤུལ་བཞག་རིག་གནས།
              </div>
              <div class="art_bottom">
                རིག་གནས་གཅེས་ནོར།|སྒྱུ་རྩལ་རྒྱུན་འཛིན།|བཟོ་བོ་མཁས་པའི་བརྩམས་ཆོས།
              </div>
            </div>
          </div>
        </div>
        <div class="middle_bottom wow animate__fadeIn animate__animated">
          <img
            class="hidden-xs-only"
            src="../../assets/cultural/Cultural_two.png"
            alt=""
          />
          <img
            class="hidden-sm-and-up"
            src="../../assets/cultural/Cultural_two_bottom.gif"
            alt=""
          />
          <div class="za_title title">
            <div class="button" @click="goCulturalCustomMade()">
              AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">རིག་གཏོད་འདྲི་རྩད།</div>
          <div class="hidden-sm-and-up">རིག་གཏོད་འདྲི་རྩད།</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="culture" v-else>
    <Pic-top></Pic-top>
    <div class="cultureTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">文创设计与展销</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="cultureContent">
      <div class="section">
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0">暂无数据</div>
        </div>
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0">暂无数据</div>
        </div>
        <div class="moreButton">
          <div class="button" @click="goMoreCultureGoods">查看更多</div>
        </div>
        <div class="middle">
          <div class="left wow animate__fadeInLeft animate__animated">
            <img
              class="hidden-xs-only"
              src="../../assets/dataType/data_one.png"
              alt=""
            />
            <img
              class="hidden-sm-and-up"
              src="../../assets/dataType/data_one_bottom.gif"
              alt=""
            />
          </div>
          <div class="right wow animate__fadeInRight animate__animated">
            <div class="right_art">
              <div class="art_top">热贡艺术</div>
              <div class="art_middle">人类物质文化遗产|中国非物质文化遗产</div>
              <div class="art_bottom">文化瑰宝|艺术传承|大师作品</div>
            </div>
          </div>
        </div>
        <div class="middle_bottom wow animate__fadeIn animate__animated">
          <img
            class="hidden-xs-only"
            src="../../assets/cultural/Cultural_two.png"
            alt=""
          />
          <img
            class="hidden-sm-and-up"
            src="../../assets/cultural/Cultural_two_bottom.gif"
            alt=""
          />
          <div class="title">
            <div class="button" @click="goCulturalCustomMade()">
              AI辅助文创定制
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">文创咨询</div>
          <div class="hidden-sm-and-up">文创咨询</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { goodsPage } from "../../api/management";
import PicTop from "../../components/picsTop.vue";
import waterFallCulture from "../../components/waterFallCulture.vue";
import waterFallMobileCulture from "../../components/waterFallMobileCulture.vue";
export default {
  components: {
    PicTop,
    waterFallCulture,
    waterFallMobileCulture
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      goodsList: [],
      queryInfo: {
        current: 1,
        pageSize: 9,
      },
      //手机
      mobileGoodsList: [],
      Info: {
        current: 1,
        pageSize: 6,
      },
      templeContact:'18997193666'
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  created() {
    this.getGoodsPage();
  },
  methods: {
    async getGoodsPage() {
      const res = await goodsPage(this.queryInfo);
      this.goodsList = res.data.records;
    },
    goMoreCultureGoods() {
      this.$router.push("/culturalMoreGoods");
    },
    goCulturalCustomMade() {
      this.$router.push("/culturalCustomMade");
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileGoodsPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        // console.log();
      }
    },
    async getMobileGoodsPage() {
      const res = await goodsPage(this.Info);
      this.mobileGoodsList = res.data.records;
    },
    //详情
    goDetail(item) {
      this.$router.push({
        path: "/culturalGoodsDetail",
        query: { id: item.id },
      });
    },
    mobileGoDetail(id) {
      this.$router.push({ path: "/culturalGoodsDetail", query: { id: id } });
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.culture {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .cultureTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .cultureContent {
    position: relative;
    .section {
      .goodsList {
        padding: 30px 0;
        .noMessage{
          display: flex;
          justify-content: center;
          letter-spacing: 4px;
          font-weight: bold;
          font-size: 24px;
          text-align: center;
        }
      }
      .moreButton {
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
        .button {
          font-size: 20px;
          font-family: "fangzang";
          padding: 10px 45px;
          border: 1px solid #e5e5e5;
          border-radius: 2px;
          cursor: pointer;
        }
        .eng_botton {
          font-family: "Times New Roman", Times, serif;
        }
      }
      .middle {
        display: flex;
        background-color: #f5f5f5;
        .left {
          img {
            width: 792px;
            display: block;
          }
        }
        .right {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .right_art {
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: right;
            .art_top {
              font-family: "fangzang";
              font-size: 28px;
            }
            .eng_art_top {
              font-family: "Times New Roman", Times, serif;
            }
            .art_middle {
              margin: 30px 0 20px 0;
            }
            .art_middle,
            .art_bottom {
              font-size: 15px;
            }
          }
        }
      }
      .middle_bottom {
        margin: 60px 0;
        position: relative;
        img {
          width: 1200px;
        }
        .title {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .button {
            font-size: 30px;
            font-family: "fangzang";
            padding: 10px 20px;
            background-color: #971118;
            color: #fff;
            border-radius: 6px;
            cursor: pointer;
          }
          .eng_button {
            font-family: "Times New Roman", Times, serif;
            padding: 10px 16px;
          }
        }
      }
    }
    .cloud_bottom {
      position: absolute;
      right: 0%;
      bottom: 0%;
    }
    .cloud_top {
      position: absolute;
      top: 0%;
      left: 0%;
    }
    .cloudLeft {
      position: absolute;
      top: -7%;
      left: 0;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      padding: 0 10px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      box-shadow: 0 0 10px #99131a;
      margin-bottom: 20px;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
  .cloudright {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 240px;
  }
}
@media (max-width: 768px) {
  .culture {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .cultureTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .cultureContent {
      margin-top: 0;
      .moblieCloudLeft {
        position: absolute;
        top: -3%;
        right: 0;
        width: 1.25rem;
      }
      .section {
        padding: 0.2rem;
        .goodsList {
          padding: .2rem 0;
          .noMessage{
            display: flex;
            justify-content: center;
            font-size: .4rem;
          }
        }
        .moreButton {
          margin: 0 0 0.5rem 0;
          .button {
            font-size: 0.3rem;
            padding: 0.15rem 0.45rem;
          }
        }
        .middle {
          display: flex;
          .left {
            img {
              width: 2.8rem;
            }
          }
          .za_left {
            img {
              height: 100%;
            }
          }
          .right {
            .right_art {
              .art_top {
                font-size: 0.3rem;
              }
              .art_middle {
                margin: 0.1rem 0;
                font-size: 0.2rem;
              }
              .art_bottom {
                font-size: 0.2rem;
              }
            }
            .za_right_art {
              .art_top {
                font-size: 0.3rem;
              }
            }
          }
        }
      }
    }
    .middle_bottom {
      margin: 0.5rem 0 !important;
      width: 100%;
      img {
        width: 100% !important;
      }
      .title {
        .button {
          font-size: 0.35rem !important;
          padding: 0.1rem 0.2rem !important;
        }
      }
      .za_title {
        .button {
          height: 0.6rem;
          font-size: 0.26rem !important;
        }
      }
      .eng_title {
        .button {
          width: 4.8rem;
          height: 0.6rem;
          line-height: 0.4rem;
          font-size: 0.24rem !important;
          padding: 0.1rem 0.14rem !important;
        }
      }
    }
    .contact {
      right: 1%;
      z-index: 1000;
      bottom: 35%;
      .message {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.25rem;
    }
  }
}
</style>
